import { validateTidalLicense } from "../../base/index.js";
import "./tag.tidal.theme.js";
import { Tag } from "./Tag.js";
import { tagClasses } from "./classes.js";
validateTidalLicense();
export {
  Tag,
  tagClasses
};
//# sourceMappingURL=index.js.map
